<template>
  <RouterView/>
</template>

<script>
export default {
  name: 'App',
};
</script>

<style lang="scss">
  @import './sass/app.scss';
</style>
